<i18n>
    [
        "global__added",
        "sublists__closetedItemsRecTray--cta",
    ]
</i18n>

<template>
    <div>
        <LoadingButton
            :labelText="$t('sublists__closetedItemsRecTray--cta')"
            :isLoading="isLoading"
            :isLoaded="isLoaded"
            :isBorderless="true"
            :useSmallFont="true"
            :isTabbable="isTabbable"
            colorVariant="light"
            class="c-catalog-add-to-list o-text--link"
            @click="handleAddToList"
        >
            <template #loaded>
                {{ $t('global__added') }}
            </template>
            {{ $t('sublists__closetedItemsRecTray--cta') }}
        </LoadingButton>
    </div>
</template>

<script setup>
import { ref } from 'vue';

import { useActions } from '~coreModules/core/js/composables/vuexHelpers';

import { ADD_PRODUCT_TO_CLOSET_LIST, CLOSET_ACTIONS_MODULE_NAME } from '~routes/closet/js/closet-actions-store';

import LoadingButton from '~coreModules/core/components/ui/buttons/LoadingButton.vue';

const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
    choiceId: {
        type: String,
        required: true,
    },
    closetListId: {
        type: String,
        required: true,
    },
    productAnalyticsData: {
        type: Object,
        required: true,
    },
    catalogResponseId: {
        type: String,
        default: null,
    },
    isTabbable: {
        type: Boolean,
        default: true,
    },
});

const isLoading = ref(false);
const isLoaded = ref(false);

const { addProductToClosetList } = useActions(CLOSET_ACTIONS_MODULE_NAME, {
    addProductToClosetList: ADD_PRODUCT_TO_CLOSET_LIST,
});

async function handleAddToList() {
    isLoading.value = true;
    // needed to display loading state on button
    await new Promise(resolver => setTimeout(resolver, 0));

    try {
        await addProductToClosetList({
            listId: props.closetListId,
            choiceId: props.choiceId,
            product: props.product,
            productAnalyticsData: props.productAnalyticsData,
            catalogResponseId: props.catalogResponseId,
        });
        isLoaded.value = true;
    } finally {
        isLoading.value = false;
    }
}
</script>

<style lang='scss'>
    .c-catalog-add-to-list {
        width: 100%;
        background-color: $nu-white;
        outline-offset: -4px;
    }
</style>
